var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.998535,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#E4EBF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 17.6555C16.5584 18.6838 15.0128 19.3045 13.3238 19.3045C9.55511 19.3045 6.5 16.2139 6.5 12.4015C6.5 8.58911 9.55511 5.49854 13.3238 5.49854C15.0128 5.49854 16.5584 6.11929 17.75 7.14757C18.9416 6.11929 20.4872 5.49854 22.1762 5.49854C25.9449 5.49854 29 8.58911 29 12.4015C29 16.2139 25.9449 19.3045 22.1762 19.3045C20.4872 19.3045 18.9416 18.6838 17.75 17.6555Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 17.6555C19.2172 16.3893 20.1475 14.5053 20.1475 12.4015C20.1475 10.2977 19.2172 8.4137 17.75 7.14757C18.9416 6.11929 20.4872 5.49854 22.1762 5.49854C25.9449 5.49854 29 8.58911 29 12.4015C29 16.2139 25.9449 19.3045 22.1762 19.3045C20.4872 19.3045 18.9416 18.6838 17.75 17.6555Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.75 7.14746C19.2172 8.4136 20.1476 10.2976 20.1476 12.4014C20.1476 14.5052 19.2172 16.3892 17.75 17.6553C16.2829 16.3892 15.3525 14.5052 15.3525 12.4014C15.3525 10.2976 16.2829 8.4136 17.75 7.14746Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard04);
export default __webpack_public_path__ + "static/media/card-04.4370a481a0f5f2cd314b078efe8ac7df.svg";
export { ForwardRef as ReactComponent };